import { useQuery } from "@tanstack/react-query";

import { postCourseAssessmentKeys } from "../../../../redux/services/postCourseAssessment";

import { getPostAssessmentQuestionApiCall } from "./utils.api";

export const useGetPostAssessmentQuestion = (payload) => {
    const {languageId , courseId }= payload;

    return useQuery({
        queryKey: postCourseAssessmentKeys.getPostCourseAssessmentKeys(),
        queryFn: () => getPostAssessmentQuestionApiCall({languageId , courseId }),
    });
}